import {observer} from 'mobx-react-lite'
import React, {useCallback} from 'react'
import {UIUtil} from 'yougile-util'
import {TaskData} from 'yougile-model'
import {Sync} from '@client/sync'
import {useBoardStore} from '@components/board/board-store'
import {WithPerfectScrollbar} from '@components/common/with-scrollbar/with-scrollbar'
import {QueuedStatsReportsTaskList} from '@components/statistics/stats-reports/queued-stats-reports-task-list'
import {useForceUpdate, useSyncEvent} from '@containers/hooks'
import {useColumnStore} from './column-store'

export const ReportColumn = observer(() => {
  const [state, store] = useColumnStore()
  const [boardState, boardStore] = useBoardStore()
  const group = store.column

  const forceUpdate = useForceUpdate()
  useSyncEvent(
    'custom',
    {filter: group?.id, companyId: group?.companyId},
    forceUpdate,
    [group]
  )

  const onGetTasks = useCallback(
    (tasks: TaskData[]) => {
      const box = Sync.getCurrentSandbox()
      store.updateAggregatedStickerValues(
        tasks.map(task => box.getHub(task.id))
      )
      store.updateReportData(tasks)
    },
    [store]
  )

  return (
    <WithPerfectScrollbar
      ref={x => x && store.setScrollBar(x)}
      className="relative px-8 -mx-8 pb-8 column-scroll-wrapper bg-background-report rounded-t-16"
      onMouseDown={boardStore.boardDragScroll()}
      wheelPropagation
      wheelSpeed={1.5}
      onScroll={boardState.tasksRenderQueue.requestToUpdatePriorities}
    >
      {!state.loading && !!group.data.report && (
        <div onMouseDown={UIUtil.setConsumed}>
          <QueuedStatsReportsTaskList
            report={group.data.report}
            onGetTasks={onGetTasks}
            boardId={group?.location}
          />
        </div>
      )}
    </WithPerfectScrollbar>
  )
})
